// Self-hosted ALTCHA proof-of-work solver (issue #71). Fetches a signed
// challenge from the configurator backend and finds the number whose
// SHA-256 hash matches, then returns the base64 payload that the backend's
// AltchaService.Verify expects. Implemented in-house rather than via the
// ALTCHA widget so there is no third-party runtime dependency and no
// external requests.

function toHex(buffer) {
    var bytes = new Uint8Array(buffer);
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        hex += bytes[i].toString(16).padStart(2, '0');
    }
    return hex;
}

// Solve the challenge. Returns the base64 payload string. The search runs
// in concurrent chunks so the proof-of-work completes in well under a
// second for the backend's difficulty.
export async function solveAltcha() {
    var response = await fetch('api/configuration/altchachallenge');
    if (!response.ok) {
        throw new Error('Could not fetch an anti-bot challenge.');
    }
    var c = await response.json();
    var encoder = new TextEncoder();
    var max = c.maxnumber || 100000;
    var CHUNK = 2000;

    for (var start = 0; start <= max; start += CHUNK) {
        var end = Math.min(start + CHUNK, max);
        var count = end - start + 1;
        var digests = await Promise.all(
            Array.from({ length: count }, function (_, i) {
                return crypto.subtle.digest(
                    'SHA-256', encoder.encode(c.salt + (start + i)));
            }));
        for (var j = 0; j < digests.length; j++) {
            if (toHex(digests[j]) === c.challenge) {
                var payload = {
                    algorithm: c.algorithm,
                    challenge: c.challenge,
                    number: start + j,
                    salt: c.salt,
                    signature: c.signature,
                };
                return btoa(JSON.stringify(payload));
            }
        }
    }
    throw new Error('Could not complete the anti-bot challenge.');
}
